var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03711 0C6.38592 7.39628e-05 6.72158 0.138576 6.97168 0.388672L10.1445 3.56836C10.3946 3.81188 10.5331 4.14727 10.5332 4.49609V11.8496C10.5332 12.5737 9.94083 13.1659 9.2168 13.166H1.31055C0.586391 13.166 0 12.5738 0 11.8496V1.31641C0.00013161 0.59244 0.59244 0.00013161 1.31641 0H6.03711ZM6.40527 3.33203C6.40527 3.65219 6.66719 3.91389 6.9873 3.91406H9.6084L6.40527 0.711914V3.33203Z",
    fill: "#9D9DE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.58008,
    y: 4.60828,
    width: 3.94994,
    height: 0.658324,
    rx: 0.329162,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.58008,
    y: 8.55823,
    width: 7.24156,
    height: 0.658324,
    rx: 0.329162,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.58008,
    y: 6.58325,
    width: 7.24156,
    height: 0.658324,
    rx: 0.329162,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.58008,
    y: 10.5332,
    width: 7.24156,
    height: 0.658324,
    rx: 0.329162,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.70b93136.svg";
export { ForwardRef as ReactComponent };